import React from "react";
import { Modal, Button } from "react-bootstrap";

const RegisterDetailModal = ({ show, onHide, register }) => {
  if (!register) return null;
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Registered User Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Name:</strong> {register.name}
        </p>
        <p>
          <strong>Email:</strong> {register.email}
        </p>
        <p>
          <strong>Phone Number:</strong> {register.phoneNumber}
        </p>
        <p>
          <strong>General Staff Type:</strong> {register.generalStaffType}
        </p>
        <p>
          <strong>Location:</strong> {register.location}
        </p>
        <p>
          <strong>Approved:</strong> {register.approved ? "Yes" : "No"}
        </p>
        <p>
          <strong>IDFY Verified:</strong> {register.idfyVerified ? "Yes" : "No"}
        </p>
        <p>
          <strong>Created Date : </strong> {formatDate(register.createdAt)}
        </p>
        <p>
          <strong>Updated At:</strong> {formatDate(register.updatedAt)}
        </p>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
          {/* Aadhar Front */}
          {register.aadharCard?.front?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Aadhar Card Front:</strong>
              </p>
              <img
                src={register.aadharCard.front.url}
                alt="Aadhar Front"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={register.aadharCard.front.url}
                download="AadharCard_Front.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}
          {/* Aadhar Back */}
          {register.aadharCard?.back?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Aadhar Card Back:</strong>
              </p>
              <img
                src={register.aadharCard.back.url}
                alt="Aadhar Back"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={register.aadharCard.back.url}
                download="AadharCard_Back.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}

          {/* Driving License */}
          {register.drivingLicense?.front?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Driving License Front:</strong>
              </p>
              <img
                src={register.drivingLicense.front.url}
                alt="Driving License Front"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={register.drivingLicense.front.url}
                download="DrivingLicense_Front.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}
          {/* Driving License */}
          {register.drivingLicense?.back?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Driving License Back:</strong>
              </p>
              <img
                src={register.drivingLicense.back.url}
                alt="Aadhar Back"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={register.drivingLicense.back.url}
                download="DrivingLicense_Back.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}

          {/* Voter Card Front */}
          {register.voterCard?.front?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Voter Card Front:</strong>
              </p>
              <img
                src={register.voterCard.front.url}
                alt="Voter Card Front"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={register.voterCard.front.url}
                download="VoterCard_Front.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}
          {/* Voter Card Back */}
          {register.voterCard?.back?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Voter Card Back:</strong>
              </p>
              <img
                src={register.voterCard.back.url}
                alt="Voter Card Back"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={register.voterCard.back.url}
                download="VoterCard_Back.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}

          {/* Parent Aadhar Front */}
          {register.parentAadharCard?.front?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Parent Aadhar Front:</strong>
              </p>
              <img
                src={register.parentAadharCard.front.url}
                alt="Parent Aadhar Front"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={register.parentAadharCard.front.url}
                download="ParentAadharCard_Front.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}
          {/* Parent Aadhar Back */}
          {register.parentAadharCard?.back?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Parent Aadhar Back:</strong>
              </p>
              <img
                src={register.parentAadharCard.back.url}
                alt="Parent Aadhar Back"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={register.parentAadharCard.back.url}
                download="AadharCard_Back.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}

          {/* Pan Card */}
          {register.panCard?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Pan Card :</strong>
              </p>
              <img
                src={register.panCard.url}
                alt="Pan Card"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={register.panCard.url}
                download="PanCard.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}
          {/* Consent Document */}
          {register.consent_document?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Consent Document:</strong>
              </p>
              <img
                src={register.consent_document.url}
                alt="Consent Document"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={register.consent_document.url}
                download="Consent_Document.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}

          {/* Police Verification */}
          {register.police_verification?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Police Verification:</strong>
              </p>
              <img
                src={register.police_verification.url}
                alt="Police Verification"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={register.police_verification.url}
                download="Police_Verification.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RegisterDetailModal;
